module.exports = __webpack_public_path__ + "tz.svg?83d91323a3d1cd2e3433028c8af8db14";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/tz.svg
// module id = 962
// module chunks = 27